//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import stVideo from '../../components/common/stVideo';
import counter from '../common/counter.vue';
export default {
    components: {
        stVideo,
        counter
    },
    data() {
        return {
            selectColor: '1',
            number: 1,
            goods: {
                versions: '加载中...',
                colorValue: "加载中...",
                photos: []
            },
            submitFlag: true, //提交按钮节流
            swiperIndex: 0,
            swiperFlag: true,
            dotLength: 0
        };
    },
    methods: {
        goBack() {
            if (this.backPath) {
                this.$router.push(this.backPath);
            } else {
                this.$router.push('/mallGoods');
            }
        },
        changeSwiper(type) {
            if (this.swiperFlag) {
                this.swiperFlag = false;
                setTimeout(() => {
                    this.swiperFlag = true;
                }, 500)
            } else {
                return false;
            }
            if (type == 1) {
                if (this.swiperIndex == 0) {
                    this.swiperIndex = this.goods.videos.length + this.goods.photos.length - 1;
                } else {
                    this.swiperIndex--;
                }
            } else {
                if (this.swiperIndex == (this.goods.videos.length + this.goods.photos.length - 1)) {
                    this.swiperIndex = 0;
                } else {
                    this.swiperIndex++;
                }
            }
        },
        loadDetail() {
            let that = this;
            that.$vux.loading.show({
                text: '加载中...'
            });
            that.$axios
                .get('/api/v1.0/lonbonShop/goodsDetails', {
                    params: {
                        goodsId: that.goodsId
                    }
                })
                .then(function (response) {
                    if (response.status == 200) {
                        let one = response.body;
                        let photos = [];
                        let videos = [];
                        let details = [];
                        one.photo.forEach(item => {
                            var file = {
                                id: item.goodsPhotoId,
                                url: sessionStorage.fileURL + item.photo,
                                file: null,
                                status: 1,
                                remotePath: item.photo
                            };
                            if (item.photoType == 0) {
                                photos.push(file);
                            }
                            if (item.photoType == 1) {
                                videos.push(file);
                            }
                            if (item.photoType == 2) {
                                details.push(file);
                            }
                        });
                        one.photos = photos;
                        one.videos = videos;
                        one.details = details;
                        one.poster = one.photos[0].remotePath;
                        that.goods = one;
                        that.dotLength = that.goods.videos.length + that.goods.photos.length
                    }
                    that.$vux.loading.hide();
                })
                .catch(function () {
                    that.$vux.loading.hide();
                });
        },
        //节流
        buttonFlag(code) {
            if (!this[code]) {
                this.$vux.toast.text('请不要快速点击');
                return false;
            } else {
                this[code] = false;
                setTimeout(() => {
                    this[code] = true;
                }, 1500);
                return true;
            }
        },
        submit(type_) {
            if (!this.buttonFlag('submitFlag')) {
                return false;
            }
            if (!sessionStorage.token) {
                this.$store.state.APPPAGE.toLoginFunc();
                return false;
            }
            if (type_ == 1) {
                let that = this;
                let orderCart = {
                    goodsId: that.goods.goodsId,
                    goodsAttributeId: that.goods.goodsAttributeId,
                    number: that.number
                };
                let data = {
                    orderCart: JSON.stringify(orderCart),
                    shopperId: that.$store.state.userInfo.shopperId
                };
                that.$axios.post('/api/v1.0/lonbonShop/saveOrderCart', that.qs.stringify(data)).then(function (response) {
                    if (response.status == 200) {
                        that.$vux.toast.show({
                            text: '已加入购物车',
                            type: 'success'
                        });
                        that.popupShow = false;
                        that.$store.state.APPPAGE.getOrderCartNum();
                    }
                });
            } else {
                this.goods.number = this.number;
                sessionStorage.readyBuyGoods = JSON.stringify([this.goods]);
                this.$router.push('/settlement');
            }
        }
    },
    mounted() {
        this.goodsId = this.$route.query.goodsId;
        this.backPath = this.$route.query.backPath;
        if (this.goodsId) {
            this.loadDetail();
        } else {
            this.goBack();
        }
        this.$nextTick(() => {
            $('#middle').animate({ scrollTop: 0 }, 0);
        });
    }
};



// WEBPACK FOOTER //
// ./src/pcComponents/goods/goodsDetail.vue